import { FramesRendererProps, FrameStyle } from './FramesRenderer.types';

const FramesRenderer = ({ theme = FrameStyle.LIGHT, data }: FramesRendererProps): React.ReactElement => {
  const { panels } = data ?? {};

  return (
    <div className="flex space-x-2" data-test-id="frames">
      {panels?.map(({ id, width, height, count }) => (
        <div
          key={id}
          className={`py-2.5 text-center rounded-md border body-base ${theme}
            ${width > height ? 'w-14 h-10' : 'w-7 h-10'}
          }`}
        >
          {count}
        </div>
      ))}
    </div>
  );
};

export default FramesRenderer;
